export function toCamelCase(input: string): string {
  return input
    .toLowerCase()
    .replace(/(?:^|\s|_)(\w)/g, (_, char) => char.toUpperCase()) // Capitalize after spaces or underscores
    .replace(/[\s_]/g, ""); // Remove spaces and underscores
}
